import React from 'react';
import { XIcon } from 'lucide-react';
import { bonuses } from '../data/salesPage';
import type { Bonus } from '../data/salesPage';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="border-t border-ink-line bg-ink-raised" data-id="element-31" data-mp="vswbo8l0sxgr">
      <div className="mx-auto max-w-6xl px-5 py-20 sm:py-28" data-id="element-32" data-mp="vqjlx990tit5">
        <p className="font-display text-sm font-bold uppercase tracking-[0.25em] text-lime" data-id="element-33" data-mp="qt09mevvvg3u">Pero eso no es todo…</p>
        <p className="mt-4 text-lg text-bone-muted" data-id="element-34" data-mp="14rrk7rbjejn8">Además de los 6 volúmenes, vas a recibir:</p>
        <h2 id="bonos" className="mt-2 font-display text-5xl font-black uppercase leading-none text-bone sm:text-7xl" data-id="element-35" data-mp="zu7tvt1kegex">6 bonos</h2>

        <div className="mt-14 grid gap-5 md:grid-cols-2" data-id="element-36" data-mp="19kauaeb0mwna">
          {bonuses.map(bonus => <BonusCard key={bonus.number} bonus={bonus} data-id="element-37" data-mp="19mdtnoy2624o" />)}
        </div>
      </div>
    </section>;
}
function BonusCard({
  bonus
}: {
  bonus: Bonus;
}) {
  return <article className="flex h-full flex-col rounded-3xl border border-ink-line bg-ink p-7 sm:p-8" data-id="element-38" data-mp="1jji790du8p9v">
      <span className="inline-flex w-fit items-center rounded-full bg-lime px-3 py-1 font-display text-xs font-black uppercase tracking-widest text-ink" data-id="element-39" data-mp="3prddy7vc8xw1">
        Bono {bonus.number}
      </span>
      <h3 className="mt-5 font-display text-2xl font-black uppercase leading-tight text-bone sm:text-3xl" data-id="element-40" data-mp="2kkrkprk3bz3">{bonus.title}</h3>
      {bonus.intro && <p className="mt-3 text-base leading-relaxed text-bone-muted" data-id="element-41" data-mp="7imbte0pxhc5">{bonus.intro}</p>}

      {bonus.itemsLabel && <p className="mt-5 text-sm font-semibold text-bone" data-id="element-42" data-mp="chz78n5nnwqc">{bonus.itemsLabel}</p>}

      {bonus.itemStyle === 'chips' && <ul className="mt-3 flex flex-wrap gap-2" data-id="element-43" data-mp="lc3wx391z24a">
          {bonus.items.map(item => <li key={item} className="rounded-full border border-ink-line bg-ink-raised px-3 py-1 text-sm text-bone" data-id="element-44" data-mp="le6rm0l5hjfc">
              {item}
            </li>)}
        </ul>}

      {bonus.itemStyle === 'questions' && <ul className="mt-5 space-y-2.5" data-id="element-45" data-mp="v8gljmpqqps6">
          {bonus.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-bone" data-id="element-46" data-mp="109w7ri3nn2c5">
              <div className="mt-0.5 h-4 w-4 shrink-0 text-lime" aria-hidden="true" data-id="element-47" data-mp="ama9dz3ce6bc" />
              {item}
            </li>)}
        </ul>}

      {bonus.itemStyle === 'avoid' && <ul className="mt-5 space-y-2.5" data-id="element-48" data-mp="kas7u9o5g1bt">
          {bonus.items.map(item => <li key={item} className="flex items-center gap-2.5 text-sm text-bone" data-id="element-49" data-mp="kd4xl905ffzf">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-alert/15" data-id="element-50" data-mp="fiqvknqzeals">
                <XIcon className="h-3 w-3 text-alert" aria-hidden="true" data-id="element-51" data-mp="t9vtnlepauu0" />
              </span>
              {item}
            </li>)}
        </ul>}

      <p className="mt-auto pt-7 font-display text-lg font-bold text-lime" data-id="element-52" data-mp="13afx8upp0bfe">{bonus.closing}</p>
    </article>;
}